<template>
  <div>

    <!--  -->
    <div class="mb-4 py-5 tac mt-4">

      <div class="tac pb-4 mx-auto" style="height: 110px; width: 300px;">
        <img v-if="$store.state.app.theme == 'dark'" src="./pic/home_pic_light.png" style="width: 100%;">
        <img v-if="$store.state.app.theme == 'light'" src="./pic/home_pic_dark.png" style="width: 100%;">
      </div>



      <div class="mt-3 i" style="font-size: 1.2em;padding: 0 50px;">
        <!-- <b style="color: red;">
          {{lg('',{
            en: '',
            zh: '火热的',
          })}}
        </b> -->
        {{lg('',{
          en: 'Blazing DeFi Playground & Cross-chain Asset Bridge',
          zh: '火热的DeFi游乐场 & 跨链资产桥',
        })}}
      </div>

      <div class="mt-4">

        <TopnavAccountBtn
          class="sp-homepage-wallet-btn-box"
          v-if="!$store.state.web3.account"
        />
        
        <!-- kk 暂不显示审计按钮了 -->
        <a 
          v-if="0"
          href="https://github.com/Lava-Swap/lava-audit-report/blob/main/Smart%20contract%20security%20audit%20report%20-%20Lava.pdf"
          target="_blank"
          class="btn btn-primary rounded"
          >
          {{lg('',{
            en: 'Audit Report',
            zh: '审计报告',
          })}}
        </a>
      </div>

      <div class="tac mt-4">
        <a
          class="btn btn-primary btn-sm px-4 mx-3"
          >
          {{lg('',{
            en: 'HECO',
            zh: '',
          })}}

          <i class="fas fa-check small ml-1"></i>
        </a>
        <a 
          href="https://bsc.lavaswap.com/" 
          target="_blank"
          class="btn btn-primary btn-sm px-4 mx-3"
          >
          {{lg('',{
            en: 'BSC',
            zh: '',
          })}}

          <i class="fas fa-external-link-alt small ml-1"></i>
        </a>
      </div>
    </div>

    <div class="mb-mx-5">

      <div class="container" style="max-width: 900px;">

        <div class="ui-card i t-gray tac mb-4">
          <div class="bg-white py-4">
            <div class="row">
              <div class="col-md-6">
                {{lg('',{
                  en: 'LAVA Price',
                  zh: 'LAVA价格',
                })}}:
                ${{$store.state.web3.token_lava_price | tofixed2 | qfw}}
              </div>
              <div class="col-md-6">
                {{lg('',{
                  en: 'HT Price',
                  zh: 'HT价格',
                })}}:
                ${{$store.state.web3.token_ht_price | tofixed2 | qfw}}
              </div>
            </div>
          </div>
        </div>

        <div class="ui-card bg-trans tac mb-4">
          <div class="bg-card py-2">
            <!-- {{lg('',{
              en: 'Total Value Locked (TVL)',
              zh: '总锁定价值（TVL）',
            })}} -->
            {{lg('',{
              en: 'Current Total LAVA Supply',
              zh: 'LAVA总流通量',
            })}}
          </div>
          <div class="py-4 bg-white">
            <h1 class="mb-t-26px">
              <!-- USD ${{total_value_locked | tofixed2 | qfw}} -->
              {{total_value_locked_b | tofixed2 | qfw}} LAVA
            </h1>
          </div>
        </div>

        <div class="row">

          <div class="col-md-6">
            
            <div class="ui-card bg-trans tac mb-3">
              <div class="bg-card py-2 tac">
                
                <span class="ui-tagicon wallet mx-2"></span>
                <br class="pc-none">
                <span>
                  {{lg('',{
                    en: 'Your LAVA Balance',
                    zh: 'LAVA余额',
                  })}}
                </span>
              </div>
              <div class="py-4 bg-white">
                <h1 class="mb-t-26px">
                  {{$store.state.web3.account_balance_lava | tofixed2 | qfw}}
                </h1>
              </div>
            </div>

          </div>
          
          <div class="col-md-6">
            
            <div class="ui-card bg-trans tac mb-3">
              <div class="bg-card py-2 tac">
                
                <span class="ui-tagicon linechart mx-2"></span>
                <br class="pc-none">
                <span>
                  {{lg('',{
                    en: 'Total LAVA Burned',
                    zh: '累计LAVA销毁量',
                  })}}
                </span>
              </div>
              <div class="py-4 bg-white">
                <h1 class="mb-t-26px">
                  {{num_current_circulating_supply | tofixed2 | qfw}} LAVA
                </h1>
              </div>
            </div>

          </div>
        </div>

        <div class="tac mb-4 i u t-gray">
          {{lg('',{
            en: 'Total LAVA Minted',
            zh: '总铸造量',
          })}}
          = 100,000,000
        </div>

        <!-- poll farm swap -->
        <div class="mx-auto" style="max-width: 500px;">

          <!--  -->
          <div class="row mb-4">
            <div class="col-6">
              <router-link
                :to="{name:'pool'}"
                class="btn btn-lg btn-primary w-100"
              >
                {{lg('',{
                  en: 'Pool',
                  zh: '流动性矿池',
                })}}
              </router-link>
            </div>
            <div class="col-6">
              <router-link
                :to="'/farm'"
                class="btn btn-lg btn-primary w-100"
              >
                {{lg('',{
                  en: 'Farm',
                  zh: '质押挖矿池',
                })}}
              </router-link>
            </div>
          </div>

          <!--  -->
          <div class="row mb-4">
            <div class="col-6">
              <a 
                href="https://exchange.lavaswap.com" 
                target="_blank"
                class="btn btn-lg w-100 btn-primary"
                >
                {{lg('',{
                  en: 'Swap Now!',
                  zh: '交易',
                })}}
              </a>
            </div>
            <!-- <div class="col-6">
              <a 
                href="https://info.lavaswap.com" 
                target="_blank"
                class="btn btn-lg w-100 btn-primary"
                >
                {{lg('',{
                  en: 'Info',
                  zh: '行情',
                })}}
              </a>
            </div> -->
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>

import main_list_stake_active from '@/data/main_list_stake.js'
import main_list_stake_inactive from '@/data/main_list_stake_inactive.js'
let main_list_stake = [].concat(main_list_stake_active,main_list_stake_inactive)

import main_list_pool_active from '@/data/main_list_pool.js'
import main_list_pool_inactive from '@/data/main_list_pool_inactive.js'
let main_list_pool = [].concat(main_list_pool_active,main_list_pool_inactive)

import {mapActions} from 'vuex'

export default {
  name: 'home',
  components: {},
  props: [],
  data() {
    return {
      num_current_circulating_supply: '-',

      arr_each_token_total_locked: [
        {id: '', value_usd: 0},
      ],

      total_value_locked_b: '-',
    }
  },
  computed: {
    dpo_balance(){
      return 1234
    },

    total_value_locked(){
      let v = this
      let sum = 0
      v.arr_each_token_total_locked.forEach(function(item){
        sum += item.value_usd
      })
      return sum
    },
  },
  watch: {},
  methods: {
    ...mapActions([
      'getTotalStake',
      'Circulate',
      'getLPPoolTotalValue',
      'Circulate2',
    ]),
    
    // 老方法，累加
    getTotalValueLocked(){
      let v = this
      main_list_stake.forEach(async function(item){
        let num = await v.getTotalStake({
          id: item.id,
          stakeTokenAddress: item.token_address,
          stakeRewardAddress: item.reward_address,
        })

        let value_usd = num * item.price_on_usd

        v.arr_each_token_total_locked.push({
          id: item.id,
          value_usd: value_usd,
        })
      })

      main_list_pool.forEach(async function(item){
        let num = await v.getLPPoolTotalValue({
          token_address: item.token_address
        })

        let value_usd = num * 2.26

        v.arr_each_token_total_locked.push({
          id: item.id,
          value_usd: value_usd,
        })
      })
    },

    async getTotalValueLocked_b(){
      let v = this
      let res = await v.Circulate2()
      v.total_value_locked_b = res
    },

    async getNumCurrentCirculatingSupply(){
      let v = this

      let num = await v.Circulate()

      v.num_current_circulating_supply = num
    },

    run(){
      // this.getTotalValueLocked()
      this.getTotalValueLocked_b()
      this.getNumCurrentCirculatingSupply()
    },
  },
  created() {
    this.run()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .index-cards{
    .ui-card{
      height: 100%;
      h2{
        margin-bottom: 0 !important;
        margin-top: 15px;
      }

    }
  }
  .sp-card-bottom-text{
    background-color: #790000;
    color: #fff;
    padding: 8px 0;
  }

  .sp-homepage-wallet-btn-box{
    /deep/ .btn{
      border-radius: 20px;
      padding-left: 20px;
      padding-right: 20px;
    }
  }
</style>